import { observable, computed } from 'mobx';
import Thumb from './Thumb';
import guid from '../../../../utils/guid';

export default class Video {
  id;
  date_created;
  modifiedDate;
  s3 = '';
  @observable transcoded = false;
  @observable thumbs = [{ s3: '' }];
  ref;

  constructor({
    id = guid(),
    date_created = new Date(),
    modifiedDate = new Date(),
    s3 = '',
    transcoded = true,
    thumbs = [{ s3: '' }]
  }) {
    this.id = id;
    this.date_created = date_created;
    this.modifiedDate = modifiedDate;
    this.s3 = s3;
    this.transcoded = transcoded;
    this.thumbs = thumbs && thumbs.length ? thumbs.map(a => new Thumb(a)) : [];
  }

  @computed
  get thumb() {
    return this.thumbs[this.thumbs.length - 1].s3;
  }

  static getDummyVideo() {
    return new Video({
      transcoded: true,
      s3:
        'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4',
      thumbs: [
        {
          s3: 'https://peach.blender.org/wp-content/uploads/dl_720p.jpg?x23406'
        }
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./src/containers/analyse/store/model/Video.js